import styles from "./my-orders-page.module.css";
import {
  useOrderStore,
  Order,
} from "entity-store/orders-store/use-orders-store";
import { MyOrderItem } from "./my-order-item";

interface MyOrdersPageProps {}

export const MyOrdersPage = (props: MyOrdersPageProps) => {
  const { orders, isLoading, isError } = useOrderStore();

  if (isLoading) {
    return <LoadingContent />;
  }
  if (isError) {
    return <ErrorContent />;
  }
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.header}>
          <h1>Orders</h1>
        </div>
        {orders && orders.length > 0 ? (
          <div className={styles.orderList}>
            {orders.map((order) => (
              <MyOrderItem key={order.id} order={order} />
            ))}
          </div>
        ) : (
          <NoOrdersContent />
        )}
      </div>
    </div>
  );
};

const LoadingContent = () => {
  return (
    <div className={styles.loadingContent}>
      <h2>Loading Orders...</h2>
      <p>Please wait while we load your orders.</p>
    </div>
  );
};

const NoOrdersContent = () => {
  return (
    <div className={styles.noOrdersContent}>
      <h2>No Orders Found</h2>
      <p>You have not placed any orders yet.</p>
    </div>
  );
};

const ErrorContent = () => {
  return (
    <div className={styles.errorContent}>
      <h2>Error Loading Orders</h2>
      <p>There was an error loading your orders. Please try again later.</p>
    </div>
  );
};
